import ClearCurrentComposition from 'actions/composition/close_current_composition';

export default function clearCommunicationComposition(context) {
  new ClearCurrentComposition(context).run();
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/lib/clear_communication_composition.js